import * as React from "react";
import { forwardRef } from "react";
const SvgMenu04 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 20, viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", null, /* @__PURE__ */ React.createElement("path", { d: "M2.5 10H17.5M2.5 5H17.5M7.5 15H17.5", strokeWidth: 1.66667, strokeLinecap: "round", strokeLinejoin: "round", stroke: "currentColor" })));
const ForwardRef = forwardRef(SvgMenu04);
export { ForwardRef as ReactComponent };
